import { Module } from "vuex";
import { RootState } from "..";
import { ADMIN_ACTIONS } from "./admin.actions";
import { ADMIN_MUTATIONS } from "./admin.mutations";
import { ProductData } from "@/interfaces/product-data.model";
import { CategoryData } from "@/interfaces/category-data.model";
import { AmountWalletCharge } from "../../interfaces/amountWalletCharge";
import { UpdateProfile } from "@/interfaces/update-profile";

export interface AdminState {
  landing: any;
  adminProducts: any[];
  productData: ProductData;
  categoryData: CategoryData;
  usersList: any;
  adminsList: [];
  amountWalletCharge: AmountWalletCharge;
  transactionsList: any;
  invoicesList: any;
  userProfile: UpdateProfile;
  createdProductId: any;
}

const INITIAL_STATE: AdminState = {
  // landing
  landing: {
    mainBanners: [],

    aboutUs: {
      orginalBanner: "",
      mainBanner: "",
      language: "Fa",
      title: "",
      description: "",
    },

    certificates: {
      language: "",
      title: "",
      text: "",
      image: "",
    },

    certificatesList: [],

    contactUs: {
      language: "",
      title: "",
      subTitle: "",
      address: "",
      email: "",
      phone: "",
    },

    majorShopping: {
      orginalBanner: "",
      mainBanner: "",
      language: "Fa",
      title: "",
      subTitle: "",
      text: "",
    },

    videoData: {
      position: "",
      video: "",
      title: "",
      subTitle: "",
      description: "",
    },

    videos: [],

    catalogData: {
      img: "",
      link: "",
      language: "",
      text: ""
    },

    catalogs: [],

    footerAddress: {
      language: "",
      address: "",
      email: "",
      phone: "",
    },

    footerAddresses: [],

    factoryAddress: {
      language: "",
      address: "",
    },

    footerAddressFactories: [],

    majorShoppingInfo: {
      language: "",
      phone: "",
      email: "",
      address: "",
    },

    majorShoppingInfos: [],

    shopMainBanner: {
      img: "",
    },

    faqData: {
      language: "",
      title: "",
      description: "",
    },

    faqs: [],

    offerData: {
      language: "",
      title: "",
      description: "",
    },

    offers: [],

    shopMainbanners: [],

    subCategoryData: {
      category: "",
      englishTitle: "",
      persianTitle: "",
      arabicTitle: "",
    },

    subCategories: [],

    homePage: {
      mainBanner: "",
      aboutUs: {
        mainBanner: "",
        language: "",
        title: "",
        subTitle: "",
        text: "",
      },

      statue: {
        language: "",
        title: "",
        text: "",
        statueImage: "",
      },

      statues: [],
    },

    productData: {
      name: "",
      img: "",
      images: [],
      category: "",
      type: "",
      amount: 0,
      description: "",
      sizes: [],
      colors: [],
    },

    selectedLandingProduct: {
      name: "",
      img: "",
      images: [],
      category: "",
      type: "",
      amount: 0,
      description: "",
      sizes: [],
      colors: [],
    },

    categoryData: {
      img: "",
      mainBanner: "",
      description: "",
      englishTitle: "",
      persianTitle: "",
      arabicTitle: "",
      categoryType: "",
      imageServices: [],
    },

    aluminiumCategory: {
      language: "",
      title: "",
    },
    potlidCategory: {
      language: "",
      title: "",
    },

    bannerCategory: {
      img: "",
    },

    categoryServices: [],

    categoryEdit: {
      img: "",
    },

    categories: [],

    landingProducts: [],

    moreBoxContent: {
      img: "",
      title: "",
      description: "",
    },

    moreBoxes: [],

    types: [
      {
        title: "قابلمه",
        _id: "pot",
      },
      {
        title: "تابه",
        _id: "pan",
      },
      {
        title: "شیر جوش",
        _id: "milk",
      },
      {
        title: "گرده",
        _id: "alominium",
      },
      {
        title: "درب",
        _id: "potlid",
      },
    ],
  },
  adminProducts: [],
  productData: {
    name: "",
    img: "",
    images: [],
    inventory: 1,
    category: "",
    amount: 0,
    userOpinions: [],
    special_sell: 0,
    description: "",
    special: false,
    newProduct: false,
  },
  createdProductId: null,
  categoryData: {
    title: "",
    parentPath: "/",
    parent: null,
  },
  userProfile: {
    fullname: "",
    address: "",
    province: "",
    city: "",
    avatar: "",
  },
  amountWalletCharge: {
    amount: 0,
  },
  usersList: [],
  adminsList: [],
  invoicesList: [],
  transactionsList: [],
};

export const admin: Module<AdminState, RootState> = {
  actions: ADMIN_ACTIONS,
  getters: {},
  mutations: ADMIN_MUTATIONS,
  state: INITIAL_STATE,
  namespaced: true,
};
